import React from "react";
import Image from "next/image";
import { s3Static } from "utils/constants";

export default function TrustedPartners() {
    const trustedPartners = [
        { name: 'Google',          logo: 'google-logo.png',          width: 120 },
        { name: 'Amazon',          logo: 'amazon-logo.png',          width: 120 },
        { name: 'JPMorgan Chase',  logo: 'chase-logo.png',  width: 120 },
        { name: 'Citigroup',       logo: 'citi-group.png',       width: 120 },
        { name: 'General Electric',logo: 'general-electric-logo.png',              width: 120 },
        { name: "Yahoo",          logo: 'yahoo-logo.png',          width: 120 },
    ];

    return (
        <section className="bg-slate-900 border-y border-white/5">
            <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
                <div className="text-center mb-10">
                    <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full mb-4">
                        <span className="text-sm">🤝</span>
                        <span className="text-xs font-medium text-white/70">Trusted By Industry Leaders</span>
                    </div>
                    <h2 className="text-2xl md:text-3xl font-extrabold text-white tracking-tight">
                        Companies That Trust Us
                    </h2>
                </div>
                <div className="grid grid-cols-3 md:grid-cols-6 gap-4 md:gap-8">
                    {trustedPartners.map((partner) => (
                        <div
                            key={partner.name}
                            className="group flex items-center justify-center bg-white/5 backdrop-blur-md rounded-2xl px-6 py-2 border border-white/10 hover:border-orange-400/30 hover:bg-white/10 transition-all duration-300"
                        >
                            <Image
                                src={s3Static + partner.logo}
                                alt={`${partner.name} logo`}
                                width={partner.width}
                                height={20}
                                className="h-10 md:h-12 w-auto object-contain brightness-0 invert opacity-60 group-hover:opacity-100 transition-opacity duration-300"
                                
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}